import { useState } from "react";
import { FaXTwitter, FaLinkedinIn, FaFacebookF, FaLink, FaCheck } from "react-icons/fa6";

interface ShareButtonsProps {
  articleId: string;
  title: string;
}

export function ShareButtons({ articleId, title }: ShareButtonsProps) {
  const [copied, setCopied] = useState(false);
  const url = `${window.location.origin}/article/${articleId}`;
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="flex items-center gap-2">
      <a
        href={`https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        className="p-2 rounded-lg text-grey hover:text-black hover:bg-black/5 transition-colors"
        aria-label="Share on X"
      >
        <FaXTwitter size={16} />
      </a>
      <a
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        className="p-2 rounded-lg text-grey hover:text-black hover:bg-black/5 transition-colors"
        aria-label="Share on LinkedIn"
      >
        <FaLinkedinIn size={16} />
      </a>
      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        className="p-2 rounded-lg text-grey hover:text-black hover:bg-black/5 transition-colors"
        aria-label="Share on Facebook"
      >
        <FaFacebookF size={16} />
      </a>
      <button
        onClick={handleCopy}
        className="p-2 rounded-lg text-grey hover:text-black hover:bg-black/5 transition-colors"
        aria-label="Copy link"
      >
        {copied ? <FaCheck size={16} className="text-green-600" /> : <FaLink size={16} />}
      </button>
    </div>
  );
}
